import { PDFDocument, PDFForm, TextAlignment } from 'pdf-lib';
import RequestService from './requestService';

export class PdfFormService {
    loadPdfDocument = async (relativePath: string): Promise<PDFDocument> => {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        };

        const pdfData = await RequestService.get<ArrayBuffer>(relativePath, headers, 'arraybuffer')
            .then(response => response.data);
        return PDFDocument.load(pdfData);
    }

    setReadOnlyTextField = (
        form: PDFForm,
        fieldName: string,
        text: string,
        alignment: TextAlignment = TextAlignment.Right
    ): void => {
        const field = form.getTextField(fieldName);
        field.setText(text);
        field.setAlignment(alignment);
        field.enableReadOnly();
    }

    downloadPdfDocument = async (pdfDocument: PDFDocument, fileName: string): Promise<void> => {
        const pdfBytes = await pdfDocument.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);
    }
}

export default new PdfFormService();
